export const Simbolos = () => {
  return (
    <div className="row">

      <div id="main" class="offset-lg-2 col-10">
        <h2>Himnos y Simbolos</h2>
      </div>
      <div class="offset-lg-1 col-lg-5">
        <div id="infocard" class="card">
          <div class="card-body">
            <h2>Himno</h2>
            <h3>Letras del Himno</h3>
            <pre>
              <p>Cantemos todos juntos</p>
              <p>El himno de nuestro jardín</p>
              <p>El lugar donde venimos</p>
              <p>A aprender y a compartir.</p>

              <p>Aquí se forman hombres,</p>
              <p>Dispuestos a servir</p>
              <p>A una patria y aun Dios querido</p>
              <p>que nos llama a amar y a compartir .</p>
              <p>¡Oh! que grande es la magia</p>
              <p>La Magia del Saber</p>
              <p>Que engrandece nuestro espíritu</p>
              <p>Con virtud ciencia y poder.</p>

              <p>
                <strong>CORO</strong>
              </p>
              <p>Formando niños creativos</p>
              <p>En este su segundo hogar</p>
              <p>Desarrollando grandes aptitudes</p>
              <p>Para soñar, crear e imaginar.</p>

              <p>Vengan niños vengan ya</p>
              <p>Vengan todos a jugar</p>
              <p>Mis maestras nos invitan a ser grandes cual no más.</p>
            </pre>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div id="infocard" class="card">
          <div class="card-body">
            <h2>Simbolos</h2>
            <h3 class="separation">Bandera</h3>
            <img
              src="https://s3.us-east-2.amazonaws.com/lamagiadelsaber.edu.co/9bdb48d5de5e1740ca5d8af795f47a77_300x230.png"
              width="240"
              heigth="120"
              alt="Card cap"
            />
            <h3 class="separation">Escudo</h3>
            <img
              src="https://s3.us-east-2.amazonaws.com/lamagiadelsaber.edu.co/logomagiadelsaber.png"
              width="240"
              heigth="240"
              alt="Card cap"
            />
          </div>
        </div>
      </div>
      </div>

  );
};
